import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"__loading"},[_c(VOverlay,{attrs:{"value":_vm.overlay,"color":"white"}},[_c(VProgressCircular,{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }